import React, { useState, useEffect } from "react";
import InputField from "../../components/InputComponent/InputField";
import ButtonWithIcon from "../../components/ButtonwithIcon/ButtonWithIcon";
import axiosInstance from "../../axiosInstance";
import IconButton from "../../components/IconButton/IconButton";

const QualificationDetails = () => {
  const [editMode, setEditMode] = useState(false);
  const [qualificationEntries, setQualificationEntries] = useState([]);

  useEffect(() => {
    fetchQualifications();
  }, []);

  const normalizeEnum = (val) => {
    if (typeof val !== "string") return "";
    return val.toUpperCase();
  };
  const fetchQualifications = async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_EMPLOYEE_URL}/qualifications/All`,
      );

      const normalizedData = (response.data.data || []).map((entry) => ({
        ...entry,
        qualificationType: normalizeEnum(entry.qualificationType),
      }));

      setQualificationEntries(normalizedData);
    } catch (error) {
      console.error("Error fetching qualifications", error);
      setQualificationEntries([]);
    }
  };
  const handleInputChange = (index, e) => {
    const { id, value } = e.target;
    const newQualifications = [...qualificationEntries];
    newQualifications[index][id] = value;
    setQualificationEntries(newQualifications);
  };

  const handleAddQualification = () => {
    setQualificationEntries([
      ...qualificationEntries,
      {
        qualificationType: "",
        degreeName: "",
        institution: "",
        percentage: "",
        courseStartDate: "",
        courseEndDate: "",
      },
    ]);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const promises = qualificationEntries.map(async (entry) => {
      const apiPath = entry.qualificationId ? "put" : "post";
      const url = `${process.env.REACT_APP_API_EMPLOYEE_URL}/qualifications`;

      return axiosInstance[apiPath](url, entry).then(() => {
        const action = entry.qualificationId ? "updated" : "added";
        console.log(
          `Qualification "${entry.degreeName}" ${action} successfully!`,
        );
      });
    });

    try {
      await Promise.all(promises);
      setEditMode(false);
      fetchQualifications();
    } catch (error) {
      console.error("Error submitting qualifications", error);
      console.log("Failed to save qualifications!");
    }
  };

  const handleDeleteQualification = async (qualificationId, degreeName) => {
    try {
      await axiosInstance.delete(
        `${process.env.REACT_APP_API_EMPLOYEE_URL}/qualifications/${qualificationId}`,
      );
      console.log(`Qualification "${degreeName}" deleted successfully!`);
      fetchQualifications();
    } catch (error) {
      console.error("Error deleting qualification", error);
      console.log("Failed to delete qualification!");
    }
  };

  return (
    <div className="profile__form">
      <h2>Qualifications</h2>
      <p>Provide your professional qualifications and certifications.</p>
      <div className="button-container" style={{ textAlign: "right" }}>
        {!editMode && (
          <IconButton
            text="Edit"
            className="edit-button"
            variant={"edit"}
            icon="mdi:pencil"
            onClick={() => setEditMode(true)}
          />
        )}
      </div>
      {!editMode ? (
        <div className="view-mode">
          {qualificationEntries.map((entry) => (
            <div className="form-group" key={entry.qualificationId}>
              <p>
                <strong>Degree Name:</strong>{" "}
                {entry.degreeName || "Not provided"}
              </p>
              <p>
                <strong>Institution:</strong>{" "}
                {entry.institution || "Not provided"}
              </p>
              <p>
                <strong>Percentage:</strong>{" "}
                {entry.percentage || "Not provided"}
              </p>
              <p>
                <strong>Course Start Date:</strong>{" "}
                {entry.courseStartDate || "Not provided"}
              </p>
              <p>
                <strong>Course End Date:</strong>{" "}
                {entry.courseEndDate || "Not provided"}
              </p>
              <div className="form-button">
                <ButtonWithIcon
                  text="Delete"
                  className="cancel-button"
                  icon="mdi:delete"
                  onClick={() =>
                    handleDeleteQualification(
                      entry.qualificationId,
                      entry.degreeName,
                    )
                  }
                />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <form onSubmit={handleFormSubmit} className="form-container">
          {qualificationEntries.map((entry, index) => (
            <div className="form-group" key={entry.qualificationId || index}>
              <div className="input-field">
                <label htmlFor="qualificationType">Qualification Type</label>
                <select
                  id="qualificationType"
                  value={entry.qualificationType}
                  onChange={(e) => handleInputChange(index, e)}
                >
                  <option value="">Select a Qualification Type</option>
                  <option value="SCHOOL">School</option>
                  <option value="PRE_UNIVERSITY">Pre-University</option>
                  <option value="BACHELOR">Bachelor</option>
                  <option value="MASTER">Master</option>
                  <option value="PHD">PhD</option>
                </select>
              </div>
              <InputField
                label="Degree Name"
                id="degreeName"
                value={entry.degreeName}
                onChange={(e) => handleInputChange(index, e)}
              />
              <InputField
                label="Institution"
                id="institution"
                value={entry.institution}
                onChange={(e) => handleInputChange(index, e)}
              />
              <InputField
                label="Percentage"
                id="percentage"
                type="number"
                value={entry.percentage}
                onChange={(e) => handleInputChange(index, e)}
              />
              <InputField
                label="Course Start Date"
                id="courseStartDate"
                type="date"
                value={entry.courseStartDate}
                onChange={(e) => handleInputChange(index, e)}
              />
              <InputField
                label="Course End Date"
                id="courseEndDate"
                type="date"
                value={entry.courseEndDate}
                onChange={(e) => handleInputChange(index, e)}
              />
            </div>
          ))}

          <div className="button-container">
            <ButtonWithIcon
              icon="material-symbols:add-circle-outline-rounded"
              text="Add Qualification"
              onClick={handleAddQualification}
              className="add-qualification"
              type="button"
            />
            <ButtonWithIcon text="Save" icon="mdi:content-save" type="submit" />
          </div>
        </form>
      )}
    </div>
  );
};

export default QualificationDetails;
